import { Text } from '@mantine/core'

import { type CoreBundle, type CoreBundleItem } from '@flecto/types'
import { Badge } from '@flecto/ui'

export type TextBundleDiscountProps = {
  row: CoreBundleItem | CoreBundle
}

export function TextBundleDiscount({ row }: TextBundleDiscountProps) {
  if ('item_type' in row && row.item_type === 'bundle') return '-'

  if ('discount_amount' in row) {
    return (
      <Badge color='green'>
        <Text c='green.5' mr='xs'>
          %
        </Text>
        {`${row.discount_amount}`}
      </Badge>
    )
  }

  return '-'
}
